import { render, staticRenderFns } from "./OrdersPicker.vue?vue&type=template&id=38a3c79c"
import script from "./OrdersPicker.vue?vue&type=script&lang=js"
export * from "./OrdersPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports